import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'
import { ReaderSummary } from '../reader_summary'
import { ReaderStatCards } from '../reader_stat_cards'
import { StatsThemeSectionBlurs } from 'app/webview/pages/stats_profile/theme/components/section_blurs'
import { useImageToBase64 } from 'hooks'
import { useCallback, useEffect } from 'react'

export const ReaderSummaryScreenshotContent = () => {
  const { colors } = useTheme()
  const year = useStats((s) => s.year)
  const theme = useStatsTheme((s) => s.theme)
  const { image, loadImage } = useImageToBase64()

  const handleLoadImg = useCallback(async () => {
    await loadImage(theme.colors.bgGradient)
  }, [loadImage, theme.colors.bgGradient])

  useEffect(() => {
    handleLoadImg()
  }, [handleLoadImg])

  return (
    <>
      <span
        className={css`
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 1;
          overflow: hidden;
        `}
      >
        <span
          className={css`
            display: block;
            width: 100%;
            height: 100%;
            background-image: url(${image});
            background-size: cover;
            background-position: top center;
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 0;
          `}
        />
        <StatsThemeSectionBlurs type="hero" />
      </span>
      <FlexBox
        className={css`
          position: relative;
          z-index: 2;
        `}
        flexDirection="column"
      >
        <FlexBox
          className={css`
            gap: 2px;
          `}
          flexDirection="column"
        >
          <Text
            type="script"
            custom={{
              fontSize: '36px',
              lineHeight: '32px',
              letterSpacing: '-1px',
            }}
            color={colors.uiWhite}
          >
            My {year}
          </Text>
          <Text
            type="header"
            custom={{
              fontSize: '46px',
              lineHeight: '42px',
              letterSpacing: '-0.5px',
            }}
            color={colors.uiWhite}
            weight="700"
          >
            Reading
            <br />
            <span>stats on Fable</span>
          </Text>
        </FlexBox>
        <div
          className={css`
            margin-top: 12px;
            margin-bottom: 20px;
            width: 100%;
          `}
        >
          <ReaderSummary hideInfoBtn hideFeedbackBtn />
        </div>
        <ReaderStatCards />
      </FlexBox>
    </>
  )
}
